import { render } from "./ClimateExplorerTool.vue?vue&type=template&id=120e03f6&scoped=true"
import script from "./ClimateExplorerTool.vue?vue&type=script&lang=js"
export * from "./ClimateExplorerTool.vue?vue&type=script&lang=js"

import "./ClimateExplorerTool.vue?vue&type=style&index=0&id=120e03f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120e03f6"]])

export default __exports__